import React, { useEffect, useState } from 'react';
import './Developers.css'
import Developer from '../Developer/Developer';
import SelectedDevs from '../SelectedDevs/SelectedDevs';
const Developers = () => {
    const [developers, setDevelopers] = useState([]);
    const [addDevList, setaddDevList] = useState([]);
    useEffect(() => {
        fetch('./data.JSON')
            .then(resp => resp.json())
            .then(data => {
                setDevelopers(data)
            });
    }, []);

    const clickHandle = (devs) => {
        const newDevlist = [...addDevList, devs];
        setaddDevList(newDevlist);
    }
    return (
        <div className='devs-container'>
            <div className='dev'>
                {
                    developers.map(devs => <Developer
                        key={devs._id}
                        clickHandle={clickHandle}
                        developers={devs}></Developer>)
                }
            </div>
            <div>
                <div className='selected-dev-container'>
                    <h2>Selected Devoloper List</h2>
                    <SelectedDevs devData={addDevList}></SelectedDevs>
                </div>
            </div>
        </div>
    );
};

export default Developers;